import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/authContext";


const ProtectedRoute = () => {
  const { authInfo } = useAuthContext();


  return authInfo?.[0]?.first_name ? <Outlet /> : <Navigate to="/" replace  />;
};

export default ProtectedRoute;
